import { isUserAuthenticated } from '../others/Configuration';
import createWishlist from '../../api/wishlist/createWishlist';
import addWishlistItem from '../../api/wishlist/addWishlistItem';
import getWishlists from '../../api/wishlist/getCacheableWishlists';
import fulfill from '../utils/fulfill';

export default class {
  _open = false;
  _prid = null;
  _catalog = null;
  _offer = null;
  _resolveShowPromise = null;
  _rejectShowPromise = null;

  constructor({ el }) {
    this.el = el;
    this.close = this.close.bind(this);
    this._handleSubmitEvent = this._handleSubmitEvent.bind(this);

    this._container = this.el.querySelector('.js-addtoWishlist-container');
    this.el.addEventListener('submit', this._handleSubmitEvent);
  }

  _getChoicesHTML(data) {
    return '';
  }

  _getNotIdentifiedHTML(data) {
    return '';
  }

  _getCompleteHTML(data) {
    return '';
  }

  _getItemsHTML(data) {
    return '';
  }

  get open() {
    return this._open;
  }

  show({ prid, catalog, offer }) {
    if (this._open) {
      throw new Error('InvalidStateError'); // https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/showModal#Exceptions
    }

    this._prid = prid;
    this._catalog = catalog;
    this._offer = offer;
    this._open = true;

    // we don't want to make an api request if user is not log in
    if (isUserAuthenticated) {
      this._container.innerHTML = this._getChoicesHTML({});
      this._updateModalWishlists();
    } else {
      this._container.innerHTML = this._getNotIdentifiedHTML({});
    }

    return new Promise((resolve, reject) => {
      this._resolveShowPromise = resolve;
      this._rejectShowPromise = reject;
    });
  }

  close() {
    if (!this._open) {
      return;
    }

    this._open = false;
  }

  async _handleSubmitEvent(event) {
    event.preventDefault();

    const form = event.target;

    const wishlistNameInput = form.elements.namedItem('wishlist_name');
    const wishlistName = wishlistNameInput.value.trim();

    /*
    FIXME get the form submitter to check if it's for create a new wishlist or add to wishlit.
    Use 2 forms for this 2 differents tasks is not possible: IE don't support (extra form) button "form" attribute: https://caniuse.com/#feat=form-attribute
    */
    if (wishlistName) {
      const { publicId } = await createWishlist(wishlistName);
      wishlistNameInput.value = '';
      await this._updateModalWishlists(publicId);
      return;
    }

    const wishlistID = form.elements.namedItem('wishlists').value;

    // API add to wishlist, ignore response (just wait)
    await fulfill(addWishlistItem(wishlistID, this._prid, this._catalog, this._offer));

    // change modal template on success
    this._container.innerHTML = this._getCompleteHTML({});

    this._resolveShowPromise(wishlistID); // resolve show promise (don't wait the modal to be closed)
  }

  async _updateModalWishlists(preselectedWishlistID = null) {
    const wishlists = await fulfill(getWishlists(true), []);
    const preselectedWishlistIndex = Math.max(
      wishlists.findIndex((wishlist) => wishlist.publicId === preselectedWishlistID),
      0
    ); // default to 0 (first)
    const wishlistChoices = wishlists.map(({ publicId: id, numberOfItems, name }, index) => ({
      id,
      name,
      numberOfItems,
      selected: index === preselectedWishlistIndex,
    }));

    this.el
      .querySelectorAll('.js-f-wishlist-dialog-form button[type=submit]')
      .forEach((element) => (element.disabled = wishlistChoices.length === 0));
    this.el.querySelector('.js-f-wishlist-dialog-count').innerText = `(${wishlistChoices.length})`;
    // create checkboxes
    this.el.querySelector('.js-f-wishlist-dialog-list').innerHTML = this._getItemsHTML({
      wishlistItems: wishlistChoices,
    });
  }
}
